// extracted by css-extract-rspack-plugin
export default {"root":"IYUihgps1UJzQR4I","main":"p0WAjSyVg909QNxV"};